import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import _ from 'lodash';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { FieldSourceType, IReportFilterControl } from 'src/app/models';
import { PortalService, ReportService } from 'src/app/services';

@Component({
    selector: 'medpt-report-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent implements OnInit {

  @Input() field!: IReportFilterControl;
  @Input() isMedPoint!: boolean;
  @Input() form!: FormGroup;
  @Output() filterChangeData = new EventEmitter<any>();
  @ViewChild('search') SearchTextBox!: ElementRef;
  dropdownSearchTextboxControl = new FormControl();
  /** list of value filtered by search keyword for multi-selection */
  public filteredDataSource: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  /** Subject that emits when the component has been destroyed. */
  private _onDestroy = new Subject<void>();

  constructor(private portalService: PortalService,
    private reportService: ReportService) { }

  ngOnInit(): void {

    let portalInfo = this.portalService.portalConfiguation.getValue();
    let sponsor = <string>portalInfo.SponsorName;
    let portalId = <number>portalInfo.PortalID;

    if (this.field.dataSource == null) {

      let promiseData: Promise<any> = new Promise(() => { });

      if (this.field.fieldSourceType == FieldSourceType.AssetCategory) {
        promiseData = this.reportService.getFilterData('Categories', sponsor, portalId, <string>this.field.dropdownGroupType);
      }

      else if (this.field.fieldSourceType == FieldSourceType.Country) {
        promiseData = this.reportService.getFilterData('Countries', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.DocumentStatus) {
        promiseData = new Promise((resolve, reject) => {
          let data = [{ Text: "Active", Value: "Active" }, { Text: "Retired", Value: "Retired" }];
          resolve(data);
        });
      }

      else if (this.field.fieldSourceType == FieldSourceType.FAQCategory) {
        promiseData = this.reportService.getFilterData('FaqCategories', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.FAQSection) {
        promiseData = this.reportService.getFilterData('FaqSections', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.Forum) {
        promiseData = this.reportService.getFilterData('Forums', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.MessageCategory) {
        promiseData = this.reportService.getFilterData('MessageCategories', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.Poll) {
        promiseData = this.reportService.getFilterData('Polls', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.PortalLevel) {
        promiseData = new Promise((resolve, reject) => {
          let data = [{ Text: "Enterprise Level", Value: "Enterprise Level" }, { Text: "Program Level", Value: "Program Level" }, { Text: "Study Level", Value: "Study Level" }];
          resolve(data);
        });
      }

      else if (this.field.fieldSourceType == FieldSourceType.PrimaryCRA) {
        promiseData = this.reportService.getFilterData('AllCRAUsers', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.SafetyReportStatus) {
        promiseData = new Promise((resolve, reject) => {
          let data = [{ Text: "Completed", Value: "Completed" }, { Text: "Incomplete", Value: "Incomplete" }, { Text: "Waived", Value: "Waived" }];
          resolve(data);
        });
      }

      else if (this.field.fieldSourceType == FieldSourceType.SafetyReportType) {
        promiseData = new Promise((resolve, reject) => {
          let data = [{ Text: "Follow-Up SUSAR", Value: "Follow-Up SUSAR" }, { Text: "Initial SUSAR", Value: "Initial SUSAR" }];
          resolve(data);
        });
      }

      else if (this.field.fieldSourceType == FieldSourceType.SiteName) {
        promiseData = (this.isMedPoint) ? this.reportService.getFilterData('AllSites', sponsor, portalId) : this.reportService.getFilterData('Sites', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.SiteRole) {
        promiseData = this.reportService.getFilterData('Roles', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.Topic) {
        promiseData = this.reportService.getFilterData('Topics', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.User) {
        promiseData = (this.isMedPoint) ? this.reportService.getFilterData('AllUsers', sponsor, portalId) : this.reportService.getFilterData('Users', sponsor, portalId);
      }

      else if (this.field.fieldSourceType == FieldSourceType.UserStatus) {
        promiseData = new Promise((resolve, reject) => {
          let data = [{ Text: "Active", Value: "Active" }, { Text: "Inactive", Value: "Inactive" }];
          resolve(data);
        });
      }

      promiseData.then((result: any[]) => {
        this.field.dataSource = _.map(result, (item: any) => {
          const text = this.field.fieldSourceType == FieldSourceType.SiteName ? item['SiteNumber'] + " - " + item[<string>this.field.textField] : item[<string>this.field.textField];
          const value = this.field.textAsValueField ? item[<string>this.field.textField] : item[<string>this.field.valueField];
          let objItem = {
            Text: text,
            Value: value,
            Visibled: true
          };
          return objItem;
        });
        this.filteredDataSource.next(this.field.dataSource.slice());


      }, () => { }).catch(() => { }).finally(() => { });
    } else {
      this.filteredDataSource.next(this.field.dataSource.slice());
    }

    /** Set filter event based on value changes */
    this.dropdownSearchTextboxControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => this.filterDropDown());

  }


  private filterDropDown() {
    if (!this.field.dataSource) {
      return;
    }
    // get the search keyword
    let search = this.dropdownSearchTextboxControl.value;
    if (!search) {
      this.filteredDataSource.next(this.field.dataSource.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredDataSource.next(
      this.field.dataSource.filter(item => item.Text.toLowerCase().indexOf(search) > -1)
    );
  }

  openedChange(e: any) {
    // Set search textbox value as empty while opening selectbox 
    this.dropdownSearchTextboxControl.patchValue('');
  }

  selectAll(all: boolean) {
    if (!all) {
      this.form.controls[this.field.controlName].setValue([]);
    } else {
      let value: any = [];
      this.field.dataSource?.forEach((item: any) => {
        value.push(item.Value);
      });
      this.form.controls[this.field.controlName].setValue(value);
    }
  }  

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
